import styled from 'styled-components';
import {dFlex, alignCenter, justifyStart, dFlexColumn} from '../../../../globalVariables/GlobalFlex';
import {headerContent} from '../sendingModalWrapper/SendingModalWrapper.css';
import {BLACK} from '../../../../globalVariables/GlobalVariables';

export const container = styled.div`
    ${headerContent}{
        ::after {
            inset-inline-end: calc(50% - 74.5px);
            inset-block-start: 30px;
            width: 149px;
            height: 122px;
        }
    }
`;

export const title = styled.h2`
    font-size: 18px;
    font-weight: bold;
    color: ${BLACK};
    margin: 0 0 10px 0;
    text-align: center;
`;

export const description = styled.p`
    font-size: 14px;
    color: ${BLACK};
    margin: 0;
    line-height: 1.4;
    text-align: center;
`;

export const formSection = styled.div`
    ${dFlexColumn};
    gap: 16px;
    flex: 1;
`;

export const inputContainer = styled.div`
    ${dFlexColumn};
    gap: 4px;
    position: relative;
`;

export const addInputSection = styled.div<{$disabled: boolean}>`
    ${dFlex};
    ${alignCenter};
    ${justifyStart};
    gap: 8px;
    margin-top: 8px;
    ${p=>p.$disabled && `
        opacity: 0.5;
    `}
`;

export const addText = styled.span`
    font-size: 14px;
    color: ${BLACK};
    text-align: start;
`;

